import React from 'react';

// Renders the monthly specials category. Shared by the public menu page and the
// admin preview so what you see in the admin is exactly what goes live.
function SpecialsBlock({ specials, className = '' }) {
  if (!specials) return null;
  const heading = (specials.heading || '').trim();
  const items = (specials.items || []).filter((it) => it && (it.name || '').trim());
  const cloud = specials.cloudTopping && (specials.cloudTopping.name || '').trim()
    ? specials.cloudTopping
    : null;

  if (!heading && items.length === 0 && !cloud) return null;

  return (
    <div className={`menu-category specials-block ${className}`.trim()}>
      {heading && <h3>{heading}</h3>}
      <div className="menu-items">
        {items.map((it, i) => (
          <div key={i} className="menu-item">
            <div className="menu-item-name">{it.name}</div>
            {(it.price || '').trim() && <div className="menu-item-price">{it.price}</div>}
            {(it.description || '').trim() && (
              <div className="menu-item-description">{it.description}</div>
            )}
          </div>
        ))}
        {cloud && (
          <div className="menu-item">
            <div className="menu-item-name">{cloud.name}</div>
            {(cloud.price || '').trim() && <div className="menu-item-price">{cloud.price}</div>}
            <div className="menu-item-description">
              This month&apos;s special cloud topping &middot; add to any drink
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SpecialsBlock;
